/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Action, ActionType    } from '@/models/action';
import { Logger                } from '@/util/logger';
import { WindowType            } from '@/screens/ide/window';
import { WindowService         } from "@/services/window.service";

/**
 *
 * @class WindowPropertiesAction
 *
 * @brief ensure properties window is open
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class WindowPropertiesAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.properties',
      type:  ActionType.Window_Properties,
      label: 'Properties',
      icon:  '<i class="fas fa-info"></i>',
      tip:   'Ensure the properties window is open'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[WindowPropertiesAction] executing...');

    this.windows.toggleWindow(WindowType.Properties);

    return true;
  }
}
